module.exports = __webpack_public_path__ + "img/prestashop_3.41d7de8c.png";